// script for for AWS SDK.
window.global ||= window;

export type {};
